<header class="atmos-page__header">
  <h1 class="atmos-page__title">Info</h1>
</header>

<!-- About -->
<section class="atmos-card">
  <div class="atmos-card__body">
    <h2 class="atmos-info__section-title">
      <mat-icon>info</mat-icon> About
    </h2>
    <p class="atmos-paragraph">
      Sky Planner is a fan-made companion website for tracking items and progress in
      <a class="atmos-text-link" href="https://www.thatskygame.com/" target="_blank" rel="noopener">Sky: Children of the Light</a>,
      a game by <a class="atmos-text-link" href="https://thatgamecompany.com/" target="_blank" rel="noopener">thatgamecompany</a>.
    </p>
    <p class="atmos-paragraph">
      Sky Planner is non-commercial, is not affiliated with thatgamecompany and is made available for informational purposes.
    </p>
  </div>
</section>

<!-- Sharing -->
<section class="atmos-card">
  <div class="atmos-card__body">
    <h2 class="atmos-info__section-title">
      <mat-icon>share</mat-icon> Sharing
    </h2>
    <p class="atmos-paragraph">
      You are free to share any page by copying the URL from the address bar or using the share button in your browser.
    </p>
    <p class="atmos-paragraph">
      Although appreciated, it is <strong>not required</strong> to credit me (Silverfeelin) when sharing the website.
      I feel like it'd be slightly dishonest to the other people that have contributed directly or indirectly by only crediting me.
      For the people that want to know more about the site, this page exists.
    </p>
  </div>
</section>

<!-- License -->
<section class="atmos-card">
  <div class="atmos-card__body">
    <h2 class="atmos-info__section-title">
      <mat-icon>description</mat-icon> License
    </h2>
    <p class="atmos-paragraph">
      Source code is
      <a class="atmos-text-link" href="https://github.com/Silverfeelin/SkyGame-Planner/" target="_blank" rel="noopener">publicly available on GitHub</a>
      under the
      <a class="atmos-text-link" href="https://github.com/Silverfeelin/SkyGame-Planner/blob/master/LICENSE" target="_blank" rel="noopener">MIT License</a>.
    </p>
    <p class="atmos-paragraph">
      This project hosts some media and screenshots captured from the game
      <a class="atmos-text-link" href="https://www.thatskygame.com/" target="_blank" rel="noopener">Sky: Children of the Light</a>
      developed by
      <a class="atmos-text-link" href="https://thatgamecompany.com/" target="_blank" rel="noopener">thatgamecompany</a>.
      The aforementioned license covers which assets are excluded from the terms of the license.
    </p>
    <p class="atmos-paragraph">
      This project uses many public packages. These are listed in the
      <a class="atmos-text-link" href="https://github.com/Silverfeelin/SkyGame-Planner/blob/master/package.json" target="_blank" rel="noopener">package.json</a>
      file. Package licenses are aggregated in
      <a class="atmos-text-link" href="/assets/3rdpartylicenses.txt">3rdpartylicenses.txt</a>.
    </p>
  </div>
</section>

<!-- Privacy -->
<section class="atmos-card">
  <div class="atmos-card__body">
    <h2 class="atmos-info__section-title">
      <mat-icon>lock</mat-icon> Privacy Policy
    </h2>
    <p class="atmos-paragraph">
      Sky Planner does not collect personal data.
      For more information, please refer to the
      <a class="atmos-text-link" routerLink="/privacy">Privacy Policy</a>.
    </p>
  </div>
</section>

<!-- Attribution -->
<section class="atmos-card">
  <div class="atmos-card__body">
    <h2 class="atmos-info__section-title">
      <mat-icon>favorite</mat-icon> Attribution
    </h2>

    <p class="atmos-paragraph">
      Thank you kindly for the
      <a class="atmos-text-link" href="https://github.com/Silverfeelin/SkyGame-Planner/pulls?q=is%3Apr" target="_blank" rel="noopener">contributions</a>
      and
      <a class="atmos-text-link" href="https://github.com/Silverfeelin/SkyGame-Planner/issues?q=is%3Aissue" target="_blank" rel="noopener">suggestions</a>
      to improve Sky Planner:
      Daw, Morybel, oWishy, Gassed1, Plutoy, nirewen, jxj3699, MichaelDavidGK, Cozukii, SympathyTea, ChakraaThePanda,
      cysketch, LividJava, A1rPun, Sebiann, jerrymann1, KuroLuv, anton-exe, honetxo, CMRMTN, redmagejoe, Uncurse,
      khaelnihal, padiose95, itsyonichi, WxyDZDgn, StarSpacewolf, thedustt
      <a class="atmos-text-link" href="https://github.com/Silverfeelin/SkyGame-Planner/graphs/contributors" target="_blank" rel="noopener">and more</a>.
    </p>

    <p class="atmos-paragraph">
      Special shout out to
      <a class="atmos-text-link" href="https://github.com/TN24680" target="_blank" rel="noopener">CMRMTN</a> and
      <a class="atmos-text-link" href="https://github.com/Uncurse" target="_blank" rel="noopener">Uncurse</a>
      for providing
      <a class="atmos-text-link" href="https://github.com/Silverfeelin/SkyGame-Data/pulls?q=is%3Apr+is%3Aclosed" target="_blank" rel="noopener">a lot of contributions</a>
      to the
      <a class="atmos-text-link" href="https://github.com/Silverfeelin/SkyGame-Data" target="_blank" rel="noopener">SkyGame-Data</a>
      project that fuels the planner!
    </p>

    <p class="atmos-paragraph">
      Various images such as item icons, spirits and cutouts displayed on this website are from contributors of the
      <a class="atmos-text-link" href="https://sky-children-of-the-light.fandom.com/wiki/Sky:_Children_of_the_Light_Wiki" target="_blank" rel="noopener">Sky: Children of the Light Fandom wiki</a>.
      Most of these images are licensed under the
      <a class="atmos-text-link" href="https://creativecommons.org/licenses/by-sa/3.0/" target="_blank" rel="noopener">CC BY-SA license</a>.
      For more information refer to the
      <a class="atmos-text-link" href="https://www.fandom.com/licensing" target="_blank" rel="noopener">Fandom licensing page</a>.
      Licensing information for copies of these images that are included in this project can be found in the GitHub repository.
    </p>

    <p class="atmos-paragraph">
      A special thanks to the wiki contributors for all their hard work and for giving me permission to show images from
      the wiki on Sky Planner. You can find out more about
      <a class="atmos-text-link" href="https://sky-children-of-the-light.fandom.com/wiki/Special:Community" target="_blank" rel="noopener">the wiki contributors here</a>.
    </p>

    <p class="atmos-paragraph">{{ wikiCredits.intro }}</p>
    <ul class="atmos-info__credits">
      @for (person of wikiCredits.people; track person.handle) {
        <li class="atmos-info__credit">
          <span class="atmos-info__credit-name">{{ person.name }}</span>
          <span class="atmos-info__credit-handle">
            <img class="atmos-info__credit-icon" src="assets/external/discord-mark-blue.svg" alt="Discord" loading="lazy"/>
            <span>{{ person.handle }}</span>
          </span>
        </li>
      }
    </ul>

    <p class="atmos-paragraph">
      Some weekly screenshots by Ash TJ in the Sky Discord have been used to correct prices of the Nesting Workshop page.
    </p>
    <p class="atmos-paragraph">
      Some Traveling Spirit price corrections were made based on infographics by Jed#9275 (new Discord handle unknown).
    </p>
    <p class="atmos-paragraph">
      Some YouTube videos by
      <a class="atmos-text-link" href="https://www.youtube.com/channel/UCTdBaJiejXA0WSOkPX0YO0w" target="_blank" rel="noopener">nastymold</a>,
      <a class="atmos-text-link" href="https://www.youtube.com/@noobmode" target="_blank" rel="noopener">Noob Mode</a>,
      <a class="atmos-text-link" href="https://www.youtube.com/@AppUnwrapper" target="_blank" rel="noopener">App Unwrapper</a>
      and
      <a class="atmos-text-link" href="https://www.youtube.com/@SkyBat" target="_blank" rel="noopener">Sky Bat</a>
      were used as a reference to find missing information for older events. Go check out their content!
    </p>

    <p class="atmos-paragraph">{{ stoatCredit.intro }}</p>
    <ul class="atmos-info__credits">
      @for (person of stoatCredit.people; track person.handle) {
        <li class="atmos-info__credit">
          <span class="atmos-info__credit-name">{{ person.name }}</span>
          <span class="atmos-info__credit-handle">
            <img class="atmos-info__credit-icon" src="assets/external/discord-mark-blue.svg" alt="Discord" loading="lazy"/>
            <span>{{ person.handle }}</span>
          </span>
        </li>
      }
    </ul>

    <p class="atmos-paragraph">{{ plutoyCredit.intro }}</p>
    <ul class="atmos-info__credits">
      @for (person of plutoyCredit.people; track person.handle) {
        <li class="atmos-info__credit">
          <span class="atmos-info__credit-name">{{ person.name }}</span>
          <span class="atmos-info__credit-handle">
            <img class="atmos-info__credit-icon" src="assets/external/discord-mark-blue.svg" alt="Discord" loading="lazy"/>
            <span>{{ person.handle }}</span>
          </span>
        </li>
      }
    </ul>

    <p class="atmos-paragraph">{{ lailaCredit.intro }}</p>
    <ul class="atmos-info__credits">
      @for (person of lailaCredit.people; track person.handle) {
        <li class="atmos-info__credit">
          <span class="atmos-info__credit-name">{{ person.name }}</span>
          <span class="atmos-info__credit-handle">
            <img class="atmos-info__credit-icon" src="assets/external/discord-mark-blue.svg" alt="Discord" loading="lazy"/>
            <span>{{ person.handle }}</span>
          </span>
        </li>
      }
    </ul>

    <p class="atmos-paragraph">
      Is your name missing? Please
      <a class="atmos-text-link" href="https://github.com/Silverfeelin/SkyGame-Planner/issues" target="_blank" rel="noopener">open a new Issue on GitHub</a>!
    </p>
  </div>
</section>

<!-- Hosting -->
<section class="atmos-card">
  <div class="atmos-card__body">
    <h2 class="atmos-info__section-title">
      <mat-icon>dns</mat-icon> Hosting
    </h2>
    <p class="atmos-paragraph">
      Sky Planner is hosted using
      <a class="atmos-text-link" href="https://pages.cloudflare.com/" target="_blank" rel="noopener">Cloudflare Pages</a>.
      <a class="atmos-text-link" href="https://www.cloudflare.com/web-analytics/" target="_blank" rel="noopener">Cloudflare Web Analytics</a>
      is enabled and captures anonymous data without tracking you. This allows for insights such as the amount of page
      visits and the distribution between desktop and mobile visits to help prioritize development.
    </p>
  </div>
</section>

<!-- Project links -->
<section class="atmos-card">
  <div class="atmos-card__body">
    <h2 class="atmos-info__section-title">
      <mat-icon>link</mat-icon> Project links
    </h2>
    <div class="atmos-info__links">
      <a class="atmos-btn" href="https://github.com/Silverfeelin/SkyGame-Planner" target="_blank" rel="noopener">
        <mat-icon>code</mat-icon> GitHub repository
      </a>
      <a class="atmos-btn" href="https://github.com/Silverfeelin/SkyGame-Data" target="_blank" rel="noopener">
        <mat-icon>storage</mat-icon> SkyGame-Data
      </a>
      <a class="atmos-btn" href="https://github.com/Silverfeelin/SkyGame-Planner/issues" target="_blank" rel="noopener">
        <mat-icon>bug_report</mat-icon> Issues
      </a>
      <a class="atmos-btn" href="https://github.com/Silverfeelin/SkyGame-Planner/blob/master/LICENSE" target="_blank" rel="noopener">
        <mat-icon>gavel</mat-icon> License
      </a>
    </div>
  </div>
</section>
